import React, { Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, useLocation } from 'react-router-dom'
import { LazyLoadingIndicator } from '../apps/common'
import { AccessControl } from './AccessControl'


const PrivateRoute = ({ children }) => {

    //SELECTORS
    const token = useSelector(store => store.auth.token)
    const permissions = useSelector(store => store.auth.permissions)

    const location = useLocation()

    const access = permissions && AccessControl.checkAccess(permissions, location.pathname)

    return token
        ? access.isPermitted
            ? <Suspense fallback={<LazyLoadingIndicator />}>
                {children}
            </Suspense>
            : <Redirect to={{
                pathname: '/forbidden',
                state: { from: location, reason: access.reason }
            }} />
        : <Redirect to={{
            pathname: '/',
            state: { from: location }
        }} />
}


export default PrivateRoute